export default "__VITE_ASSET__BrjBRoyv__"